// extracted by mini-css-extract-plugin
module.exports = {"link":"useColumns_link__3rYtq","integration":"useColumns_integration__1aZIb","icon":"useColumns_icon__2fNr8"};